import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaOrganoDireccion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [postFecha, setPostFecha] = useState("");
  const [postLogro, setPostLogro] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpenModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const postData = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaOrganosControl",
        data: {
          Fecha: postFecha || "0001-01-01",
          Logro: postLogro,
          SolicitudId: props.idSolicitud,
        },
      });

      // 🔹 Notifica al padre
      props.onRegistroCreado({
        logro: postLogro,
        fecha: postFecha,
      });

      alert("Añadido con éxito");
      setPostFecha("");
      setPostLogro("");
      closeModal();
    } catch (error) {
      console.error(error);
      alert("Error al crear el registro");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-3">
      <button className="btn btn-primary btn-lg" onClick={handleOpenModal}>
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
      >
        <div className="card shadow">
          <div className="card-header">
            <h6 className="font-weight-bold text-primary">
              Crear Órgano de Dirección
            </h6>
          </div>

          <div className="card-body">
            <form onSubmit={postData}>
              <div className="form-group">
                <label>Fecha de conformación</label>
                <input
                  type="date"
                  className="form-control"
                  value={postFecha}
                  onChange={(e) => setPostFecha(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Logros</label>
                <input
                  type="text"
                  className="form-control"
                  value={postLogro}
                  onChange={(e) => setPostLogro(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loading}
              >
                {loading ? "Guardando..." : "Guardar"}
              </button>
            </form>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaOrganoDireccion;
